export default "__VITE_ASSET__BornPy_U__"